<div class="mp-page">
  <header class="mp-header">
    <button type="button" class="mp-back" (click)="cancel()" aria-label="Back">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>
    </button>
    <div class="mp-heading">
      <h1 class="mp-title">Departure date</h1>
      <p class="mp-sub">{{ selected ? (selected | date:'EEEE, d MMMM y') : 'Pick the day you fly out' }}</p>
    </div>
  </header>

  <div class="mp-body">
    <div class="mp-card mp-calendar">
      <mat-calendar
        [minDate]="minDate"
        [startAt]="selected || minDate"
        [(selected)]="selected"
        (selectedChange)="onDateSelected($event)">
      </mat-calendar>
    </div>
    <p class="mp-hint">
      <i class="far fa-hand-point-up" aria-hidden="true"></i>
      Tap a date to select it.
    </p>
  </div>
</div>
